import angular from 'angular';
import moment from 'moment';
import { IPagamentoConfirmModal } from '../../../models/pagamentoponto.model';

export class PagamentosPontoConfirmModalController {
    static $inject = [
        '$uibModalInstance',
        'entity',
    ];

    public form: angular.IFormController;
    public meses = [
        { value: 1, label: 'Janeiro' },
        { value: 2, label: 'Fevereiro' },
        { value: 3, label: 'Março' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Maio' },
        { value: 6, label: 'Junho' },
        { value: 7, label: 'Julho' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Setembro' },
        { value: 10, label: 'Outubro' },
        { value: 11, label: 'Novembro' },
        { value: 12, label: 'Dezembro' },
    ];
    public anos: number[];

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public entity: IPagamentoConfirmModal,
    ) {
        const anoAtual = moment().year();
        this.anos = [anoAtual - 1, anoAtual, anoAtual + 1];
    }

    verificaoMesAno() {
        const mes = Number(this.entity.mes);
        const ano = Number(this.entity.ano);

        if (!mes || mes < 1 || mes > 12 || !ano) {
            return false;
        }

        const dataReferencia = this.entity.fechamentoProximoMes
            ? moment({ year: ano, month: mes - 1, date: 1 }).add(1, 'month')
            : moment({ year: ano, month: mes - 1, date: 1 });

        const diaFechamento = parseInt(this.entity.diaFechamento, 10);

        if (!diaFechamento || diaFechamento < 1) {
            return false;
        }

        // garante que o dia não ultrapasse o último dia do mês
        const ultimoDiaDoMes = dataReferencia.daysInMonth();
        const diaAjustado = Math.min(diaFechamento, ultimoDiaDoMes);

        const dataFinal = dataReferencia
            .clone()
            .date(diaAjustado)
            .startOf('day');

        return moment().startOf('day').isAfter(dataFinal);
    }

    confirmar() {
        if (this.form.$invalid) {
            return;
        }
        this.$uibModalInstance.close(this.entity);
    }

    fechar() {
        this.$uibModalInstance.dismiss('cancelar');
    }
}
